import { render } from "./Tables.vue?vue&type=template&id=a1d55840&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=a1d55840&scoped=true&lang=css"

import exportComponent from "/Users/ran/Development/temp/invitee-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d55840"]])

export default __exports__